import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { trackCustomEvent } from '../../utils/trackCustomEvent';

import Footer from '../footer';
import Header from '../header';
import Dialog from '../dialog';

import './layout.css'; // import "layout.css" first
import '../footer/footer.css';
import './grid.css';
import '../header/header.css';

import 'typeface-roboto';

const Layout = ({ children }) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    navLinks {
                        name
                        route
                    }
                    siteTitle
                }
            }
        }
    `);

    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        window.addEventListener('setDialogOpen', handleSetDialogOpenEvent);

        return () =>
            window.removeEventListener(
                'setDialogOpen',
                handleSetDialogOpenEvent
            );
    });

    const handleDialogClose = (trackEvent = true) => {
        if (trackEvent) {
            // Track the dialog close in Google Analytics
            trackCustomEvent({
                event: 'contact-dialog',
                'contact-dialog-action': 'Close',
            });
        }

        setDialogOpen(false);
    };

    const handleDialogSubmit = async (data, reCAPTCHAToken) => {
        console.log('Form data', data);
        console.log('reCAPTCHAToken', reCAPTCHAToken);

        // Track the submit in Google Analytics
        trackCustomEvent({
            event: 'contact-dialog',
            'contact-dialog-action': 'Submit',
        });

        let html = '';
        for (let [key, value] of Object.entries(data)) {
            html += key + ': ' + value + ',<br></br>';
        }

        return await fetch(
            'https://us-central1-weaveiq-platform.cloudfunctions.net/emailer',
            {
                body: JSON.stringify({
                    body: 'Weave got a live one!',
                    from: 'support@weaveiq.com',
                    html,
                    subject: `Demo Request From ${data.first} ${data.last}`,
                    to: 'sales@weaveiq.com',
                }),
                headers: {
                    Authorization: `Bearer ${reCAPTCHAToken}`,
                },
                method: 'POST',
            }
        );
    };

    const handleSetDialogOpenEvent = event => {
        event.preventDefault();
        console.log('handleSetOpenEvent running!', event.detail);

        // Track the open in Google Analytics
        trackCustomEvent({
            event: 'contact-dialog',
            'contact-dialog-action': 'Open',
        });

        setDialogOpen(true);
    };

    return (
        <>
            <Header
                navLinks={data.site.siteMetadata.navLinks}
                siteTitle={data.site.siteMetadata.siteTitle}
            />
            <main className="layout-parallax">
                {children}
                <Footer />
            </main>
            <Dialog
                isOpen={dialogOpen}
                onClose={handleDialogClose}
                onSubmit={handleDialogSubmit}
            />
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
